"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _radioBoxes = require("@vds-core/radio-boxes");
var propTypes = {
  /**
   * @deprecated inputId
   * Allows a unique ID to be passed to the input element.
   */
  uniqueId: _propTypes["default"].string,
  /**
   * @deprecated selected
   * If provided, the RadioBox will be rendered in the active State.
   */
  active: _propTypes["default"].bool,
  /**
   * If provided, will render the red top line when active/selected
   */
  orientation: _propTypes["default"].oneOf(["horizontal", "vertical"])
};
var RadioBox = function RadioBox(props) {
  var uniqueId = props.uniqueId,
    inputId = props.inputId,
    active = props.active,
    selected = props.selected,
    orientation = props.orientation;
  return /*#__PURE__*/_react["default"].createElement(_radioBoxes.RadioBox, (0, _extends2["default"])({}, props, {
    orientation: orientation !== undefined ? orientation : "horizontal",
    selected: active !== undefined ? active : selected,
    inputId: uniqueId !== undefined ? uniqueId : inputId,
    transparentBackground: false // Brand 3.0 only
    ,
    borderColor: "#747676",
    borderRadius: "0",
    borderColorActive: "#000000",
    borderColorSelected: "#D52B1E",
    borderActiveIndicator: "highlight",
    fontSize: "12px",
    lineHeight: "16px",
    letterSpacing: "0",
    surface: "light",
    subtextRight: "" // Brand 3.0 only
  }));
};

RadioBox.propTypes = propTypes;
var _default = exports["default"] = RadioBox;


//////////////////
// WEBPACK FOOTER
// ./~/@vds/radio-boxes/dist/cjs/components/RadioBox.js
// module id = 584
// module chunks = 0